import React, { Component } from 'react';

import Email from './Email';
import Password from './Password';
import MFA from './MFA';

class Login extends Component {
  state = {
    action: 'request',
    email: '',
    emails: [],
    requestId: ''
  };

  handleUpdateSession = ({ email, emails, action, requestId }) => {
    this.setState({ ...this.state, email, emails, action, requestId });
  };

  render() {
    const { action } = this.state;

    switch (action) {
      case 'auth':
        return <Password onUpdateSession={this.handleUpdateSession} {...this.state} />;
      case 'mfa':
        return <MFA onUpdateSession={this.handleUpdateSession} {...this.state} />;
      case 'request':
      case 'login':
      default:
        return <Email onUpdateSession={this.handleUpdateSession} {...this.state} />;
    }
  }
}

export default Login;
